// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuActionButton_wrapper__2JQDd"};